<input [style]="{'text-align': element._get('horizontalTextAlignment')}" [value]="element._get('data')" [readonly]="element._get('readOnly')" [attr.maxlength]="element._get('maxLength')">

